import { states } from 'states-us';

export const getStateOptions = (isAdminView = false) => {
  return states.reduce(
    (states, currentState) => {
      if (!currentState.territory || currentState.abbreviation === 'PR') {
        states.push({ label: currentState.name, value: currentState.abbreviation });
        if (isAdminView && currentState.abbreviation === 'NY') {
          states.push({ label: 'New York - New York City', value: 'NY-NYC' });
        }
      }
      return states;
    },
    [] as Array<{ label: string; value: string }>,
  );
};
